import axios from '../api' // 倒入 api
export const order = {
  // 通过订单号查询状态
  getOrderStateByOrderNo: data => {
    return axios({
      url: '/huizb-app/appOrder/getOrderStateByOrderNo',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 下单接口
  createOrder: (data, url) => {
    return axios({
      url: url,
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 微信支付
  wxPay: data => {
    return axios({
      url: '/huizb-app/appPay/wxPay',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 获取PDF
  getAuthorizationPdf: (data, url) => {
    return axios({
      url: url,
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 授权列表
  getEmpowerOrgList: data => {
    return axios({
      url: '/hui-signature/base/associationSys/getEmpowerOrgList',
      method: 'post',
      base: 'SIGN',
      loading: true,
      data
    })
  },
  // 签章信息
  getOrgSignList: data => {
    return axios({
      url: '/hui-signature/base/associationSys/getOrgSignList',
      method: 'post',
      base: 'SIGN',
      loading: true,
      data
    })
  },
  // 签章次数
  getUserQuestionSignCountNum: data => {
    return axios({
      url: '/huizb-app/order/getUserQuestionSignCountNum',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 签章下单
  submitOrder: data => {
    return axios({
      url: '/huizb-app/appOrder/submitOrder',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 签章获取验证码
  sendBJCAVerificationCode: data => {
    return axios({
      url: '/hui-signature/base/associationSys/sendBJCAVerificationCode',
      method: 'post',
      base: 'SIGN',
      data
    })
  },
  // 签章
  signFile: data => {
    return axios({
      url: '/hui-signature/base/associationSys/signFile',
      method: 'post',
      base: 'SIGN',
      data
    })
  },
  checkBJCAVerificationCode: data => {
    return axios({
      url: '/hui-signature/base/associationSys/checkBJCAVerificationCode',
      method: 'post',
      base: 'SIGN',
      data
    })
  },
  sendRequestCheckBJCAVerificationCode: data => {
    return axios({
      url: '/huizb-app/myOrder/sendRequestCheckBJCAVerificationCode',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  getSupplierAnalyDetailInfo: data => {
    return axios({
      url: '/huizb-app/order/getSupplierAnalyDetailInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  saveSupplierAnalyInfo: data => {
    return axios({
      url: '/huizb-app/order/saveSupplierAnalyInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  updateSupplierAnalyInfo: data => {
    return axios({
      url: '/huizb-app/order/updateSupplierAnalyInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  getCreditArea: data => {
    return axios({
      url: '/huizb-app/appCredit/getCreditArea',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  getByParentId: data => {
    return axios({
      url: '/huizb-app/orgContent/getByParentId',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  getContentsNextGrade: data => {
    return axios({
      url: '/coi/huicoreapi/baseContents/v1/getContentsNextGrade',
      method: 'post',
      base: 'CORE',
      data
    })
  },
  getOrgPositionIndustryPromiseBookPdf: data => {
    return axios({
      url: '/huizb-app/appCredit/getOrgPositionIndustryPromiseBookPdf',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
}
export default order